import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {EditDataService} from "../services/edit-data.service";
import {ToastsManager} from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'app-prolongation',
  templateUrl: './prolongation.component.html',
  providers: [ToastsManager],
  styleUrls: ['./prolongation.component.scss']
})
export class ProlongationComponent implements OnInit {

  public password: any;
  public dataProlongation: any;
  public filiationId: any;
  public filiations: any;

  constructor(public editDataService: EditDataService,
              public vRef: ViewContainerRef,
              public toastr: ToastsManager) {

    this.toastr.setRootViewContainerRef(vRef);
    this.password = this.editDataService.password;

    editDataService.getProlongation().subscribe(
      data => {
        this.dataProlongation = JSON.parse(data["_body"]);
        this.filiations = {};
        this.filiations[0] = {value: -1, viewValue: "Отримати по усім"};
        this.dataProlongation.forEach((prolongation) => {
          if (!(prolongation.filiationId in this.filiations)) {
            this.filiations[prolongation.filiationId] = {
              value: prolongation.filiationId,
              viewValue: "Відділення " + prolongation.filiationId
            }
          }
        });
        this.filiations = Object.keys(this.filiations).map(key => this.filiations[key]);
        this.filiationId = {value: -1, viewValue: "Отримати по усім"};
        //console.log(this.filiations);
      },
      error => {
        error = JSON.parse(error._body);
        this.toastr.error(error.message, error.status_code,{dismiss: 'click'});
      }
    );
  }

  /**
   * Для подсчёта высоты грида на ходу
   * @returns {string}
   */
  countHeight() {
    return 420 + "%";
  }

  receiveProlongations() {
    this.editDataService.SendReqForProlongations(this.filiationId, this.password).subscribe(
      data => {
        let link = JSON.parse(data["_body"]).name;
        console.log(link);
        window.open(link);
      },
      error => {
        error = JSON.parse(error._body);
        this.toastr.error(error.message, error.status_code,{dismiss: 'click'});
      });
  }



  ngOnInit() {
  }

}




// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/prolongation/prolongation.component.ts